import { render, staticRenderFns } from "./TrekButton.vue?vue&type=template&id=60175dc6&"
import script from "./TrekButton.vue?vue&type=script&lang=js&"
export * from "./TrekButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports